import axios from "../utils/axios";

export function userChartCreate(data, callback, errorcallback) {

    axios({
        method: 'post',
        url: process.env.REACT_APP_API_SERVER + '/user-chart',
        data: data
    }).then(response => {
        if (callback != null) {
            callback(response);
        }
    }).catch(err => {
        if (errorcallback != null) {
            errorcallback(err);
        } else {
            console.log(err);
        }
    });


}

export function userChartEdit(data, callback, errorcallback) {

    axios({
        method: 'PUT',
        url: process.env.REACT_APP_API_SERVER + '/user-chart/edit/' + data._id,
        data: data
    }).then(response => {
        if (callback != null) {
            callback(response);
        }
    }).catch(err => {
        if (errorcallback != null) {
            errorcallback(err);
        } else {
            console.log(err);
        }
    });


}

export function userChartGet(id, callback, errorcallback) {

    axios({
        method: 'GET',
        url: process.env.REACT_APP_API_SERVER + '/user-chart/' + id,
    }).then(response => {
        if (callback != null) {
            callback(response);
        }
    }).catch(err => {
        if (errorcallback != null) {
            errorcallback(err);
        } else {
            console.log(err);
        }
    });


}

export function userChartGetByDashboardID(data, callback, errorcallback) {

    axios({
        method: 'GET',
        url: process.env.REACT_APP_API_SERVER + '/user-chart/user/' + data.userId + '/dashboard/' + data.dashboardID,
    }).then(response => {
        if (callback != null) {
            callback(response);
        }
    }).catch(err => {
        if (errorcallback != null) {
            errorcallback(err);
        } else {
            console.log(err);
        }
    });


}

export function userChartGetAllActive(username, callback, errorcallback) {

    axios({
        method: 'GET',
        url: process.env.REACT_APP_API_SERVER + '/user-chart/user/' + username + "/active/true",
    }).then(response => {
        if (callback != null) {
            callback(response);
        }
    }).catch(err => {
        if (errorcallback != null) {
            errorcallback(err);
        } else {
            console.log(err);
        }
    });

}

export function userChartDelete(id, callback, errorcallback) {
    axios({
        method: 'DELETE',
        url: process.env.REACT_APP_API_SERVER + '/user-chart/' + id,
    }).then(response => {
        if (callback != null) {
            callback(response);
        }
    }).catch(err => {
        if (errorcallback != null) {
            errorcallback(err);
        } else {
            console.log(err);
        }
    });
}